module.exports = __webpack_public_path__ + "static/media/template5.85e60f0b.webp";